import React from 'react';
import './Footer.css';
import logo from '../assets/logo.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer-container">
        
        {/* Column 1: Brand */}
        <div className="footer-col">
          <div className="footer-brand">
            <div className="footer-logo-circle">
              <img src={logo} alt="Bright Angel Logo" />
            </div>
            <h2>Bright Angel Global Education</h2>
          </div>
          <p className="footer-tagline">Empowering Your Global Education Journey.</p>
          <p className="footer-description">
            Bright Angel Global Education is a trusted division of Bright Angel Foreign Employment Agency (Pvt) Ltd., providing expert guidance for student visas, university placements, and studying abroad.
          </p>
          <div className="social-links">
            <a href="https://www.facebook.com/brightangelstudyabroad" target="_blank" rel="noopener noreferrer" className="social-icon" title="Facebook">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.04c-5.5 0-9.96 4.46-9.96 9.96 0 5.09 3.82 9.29 8.76 9.87v-7.14h-2.22V12h2.22V9.89c0-2.4 1.34-3.6 3.32-3.6 1.05 0 2 .08 2.27.11v2.54h-1.55c-1.22 0-1.58.58-1.58 1.48V12h3.04l-.4 2.69h-2.64v7.36c5.56-.41 9.7-5.06 9.7-10.74 0-5.5-4.46-9.96-9.96-9.96z"/></svg>
            </a>
            <a href="https://www.twitter.com/brightangel" target="_blank" rel="noopener noreferrer" className="social-icon" title="Twitter">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71-.02-1.37-.22-1.95-.54v.05c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.52 8.52 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"/></svg>
            </a>
            <a href="https://www.linkedin.com/company/bright-angel-study-abroad" target="_blank" rel="noopener noreferrer" className="social-icon" title="LinkedIn">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"/></svg>
            </a>
            <a href="https://www.instagram.com/brightangel_studyabroad" target="_blank" rel="noopener noreferrer" className="social-icon" title="Instagram">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z"/></svg>
            </a>
          </div>
        </div>

        {/* Column 2: Quick Links */}
        <div className="footer-col">
          <h3 className="footer-title">Quick Links</h3>
          <ul className="footer-links">
            <li><a href="/">Home</a></li>
            <li><a href="#destinations">Destinations</a></li>
            <li><a href="#about">Why Choose Us?</a></li>
            <li><a href="#contact">Contact Us</a></li>
          </ul>
        </div>

        {/* Column 3: Contact Us */}
        <div className="footer-col contact-details">
          <h3 className="footer-title">Contact Us</h3>
          <ul>
            <li>
              <span>📍</span> 48/3/1, Galle Road, Dehiwala, Sri Lanka
            </li>
            <li>
              <span>📞</span> +94 777 897 304
            </li>
            <li>
              <span>📞</span> +94 11 490 4530
            </li>
            <li>
              <span>✉️</span> studyvisa@brightangel.lk
            </li>
          </ul>
          
          <div className="other-company">
            <span>🌐</span>
           <div>
              <p>Our Other Company Websites</p>

              <a
                href="https://www.brightangelgroup.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.brightangelgroup.com ↗
              </a>

              <br />

              <a
                href="https://brightangel.lk/"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.brightangel.lk ↗
              </a>
            </div>
          </div>
        </div>

        {/* Column 4: Inquiry */}
        <div className="footer-col">
          <h3 className="footer-title">Inquiry</h3>
          <p className="inquiry-text">Send us a quick message</p>
          <div className="inquiry-form">
            <input type="email" placeholder="Your Email" className="inquiry-input" />
            <button className="inquiry-btn">Send</button>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>Government Approved License No: 3762 | Registration: PV00323570</p>
        <p>&copy; 2026 Bright Angel Foreign Employment Agency (Pvt) Ltd. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
